import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { Links } from './../models/businessLink';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BusinessLinksService {
  constructor(private http: HttpClient) {}

  getLinksByBusinessId(bid: number) {
    return this.http
      .get<any>(
        environment.BASE_URL +
          '/links/linklist/' +
          bid +
          '/' +
          BaseServices.UserRole
      ).pipe(rxjsmap(result => result));
  }

  getLinksByPortalId(portalId: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/links/portallinklist/' + portalId).pipe(rxjsmap(result => result));
  }

  getLinksById(id: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/links/link/' + id).pipe(rxjsmap(result => result));
  }
  createLink(links: Links) {
    return this.http
      .post(environment.BASE_URL + '/links/link', links).pipe(rxjsmap(result => result));
  }

  updateLink(id: number, links: Links) {
    return this.http
      .put(environment.BASE_URL + '/links/link/', links).pipe(rxjsmap(result => result));
  }

  deleteById(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/links/linksdelete/' + id).pipe(rxjsmap(result => result));
  }
}
